export const SESSION_MODES = ['medical_diagnosis', 'medical_intervention', 'nurse'];
export const DEFAULT_SESSION_MODE = 'medical_intervention';

const LEGACY_SESSION_MODE_LABELS = {
  doctor: 'Medical Intervention',
};

export const SESSION_MODE_OPTIONS = [
  { value: 'medical_diagnosis', label: 'Medical Diagnosis' },
  { value: 'medical_intervention', label: 'Medical Intervention' },
  { value: 'nurse', label: 'Nurse' },
];

export function sessionModeLabel(mode) {
  const key = String(mode || '').trim().toLowerCase();
  if (LEGACY_SESSION_MODE_LABELS[key]) return LEGACY_SESSION_MODE_LABELS[key];
  return SESSION_MODE_OPTIONS.find((option) => option.value === key)?.label || mode || 'Medical Intervention';
}

export function sessionModeChipColor(mode) {
  const key = String(mode || '').trim().toLowerCase();
  if (key === 'nurse') return 'secondary';
  if (key === 'medical_diagnosis') return 'info';
  return 'primary';
}
